const icon = require('./icons/sleeping-in-bed-100.png')

export const InBedIcon = () => {
  return <img src={icon} alt="in bed icon" className="w-full h-full"/>
}
